import { z } from "zod"

export const Request = {
  ValidateEmailChange: z.object({
    confirmation_token: z.string(),
    data_type: z.string().optional(),
    id: z.string(),
  }).safeParse,
}

export const Response = {
  ValidateEmailChange: z.object({
    message: z.string(), // e.g., "Email successfully validated"
    success: z.boolean(),
  }).safeParse,
}

export const Error = {
  ValidateEmailChange: z.object({
    error: z.string(), // e.g., "Invalid token or expired"
  }).safeParse,
}
